import { motion } from "framer-motion";
import { GraduationCap, ArrowRight } from "lucide-react";

const FACTS = [
  { k: "Product", v: "DELF Success Academy" },
  { k: "Pricing", v: "$79 / $147 / $297" },
  { k: "Target", v: "DELF A2, B1 & B2 candidates" },
  { k: "Lead Magnet", v: "\u201CHow to Succeed in the DELF B2 Exam\u201D" },
  { k: "Value Offer", v: "Free DELF B2 Masterclass" },
  { k: "Partnerships", v: "Podcast interview · YouTube collab · Group presentation · IG Live" },
];

const PIPELINE = [
  "Discover", "Qualify", "Research", "Value", "Relationship",
  "Partnership", "Lead", "Sale", "Revenue",
];

export default function DemoCampaign() {
  return (
    <section data-testid="demo-campaign-section" className="border-t border-white/10 bg-[#0A0A0A]">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative overflow-hidden border border-[#27272A]"
        >
          <img
            src="https://images.unsplash.com/photo-1692119442094-45806e38a35e?auto=format&fit=crop&w=1800&q=80"
            alt="Classic French architecture"
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/75" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />

          <div className="relative grid gap-12 p-8 lg:grid-cols-2 lg:p-16">
            <div>
              <p className="inline-flex items-center gap-2 border border-[#D4AF37]/40 bg-black/50 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.24em] text-[#D4AF37] backdrop-blur-md">
                <GraduationCap className="h-3.5 w-3.5" />
                First Demonstration Campaign
              </p>
              <h2 className="mt-6 font-serif text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">
                DELF Success Academy
              </h2>
              <p className="mt-5 max-w-md text-base leading-relaxed text-zinc-300">
                Watch the complete journey run end to end — from a niche and a handful of keywords
                to booked appearances, captured leads and attributed revenue. One product-agnostic
                engine, proven on a real campaign.
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-y-2">
                {PIPELINE.map((p, i) => (
                  <span key={p} className="flex items-center">
                    <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-zinc-200">
                      {p}
                    </span>
                    {i < PIPELINE.length - 1 && (
                      <ArrowRight className="mx-2 h-3 w-3 text-[#D4AF37]" />
                    )}
                  </span>
                ))}
              </div>
            </div>

            <div className="border border-white/15 bg-black/55 backdrop-blur-xl">
              <p className="border-b border-white/10 px-8 py-4 text-[10px] font-bold uppercase tracking-[0.24em] text-zinc-400">
                Campaign Blueprint
              </p>
              <ul className="divide-y divide-white/10">
                {FACTS.map((f) => (
                  <li key={f.k} className="grid gap-1 px-8 py-4 sm:grid-cols-[140px_1fr] sm:gap-4">
                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-zinc-500">
                      {f.k}
                    </span>
                    <span className="text-sm text-zinc-200">{f.v}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
